module.exports = __webpack_public_path__ + "eaf412dba18a9cb51bd7fd00880241c6.svg";